/* Router */
import {
    BrowserRouter as Router,
    Routes,
    Navigate,
    Route,
    useLocation
} from "react-router-dom"

import { ToastProvider } from 'react-toast-notifications'

/* Views */
import AssetScreenshot from "./views/AssetScreenshot"
import CheckoutDev from "./views/CheckoutDev"

import Dashboard from "./views/Dashboard"
import Download from "./views/Download"
import GeneralLayout from "./components/layout/General"
import Home from "./views/Home"
import Login from "./views/Login"
import Lost from "./views/Lost"
import Products from "./views/Products"
import Profile from "./views/Profile"
import Purchase from "./views/Purchase"
import Resources from "./views/Resources"
import Transaction from "./views/Transaction"
import Worlds from "./views/Worlds"

/* Components */
import { useStores } from "context/RootStoreContext"

import PrivateRoute from "./components/utilities/PrivateRoute"
import CryptoDash from "components/dashboard/CryptoDash"
import AdminDash from "components/dashboard/AdminDash"
import FormEditDashboard from "components/dashboard/FormEditDashboard"
import OverviewDash from "components/dashboard/OverviewDash"
import Layout from "components/layout/Layout"
import AdminUserDash from "components/admin/AdminUserDash"
import QueryBuilderView from "views/QueryBuilderView"
import SingleView from "CHROMA-React/components/views/Single"
import Overview from "CHROMA-React/components/views/Overview"
import AdminAffiliateDash from "components/dashboard/AdminAffiliateDash"
import AffiliateDash from "components/affiliates/AffiliateDash"
import AdminTransactionDash from "components/admin/AdminTransactionDash"
import ReleaseNotesDash from "components/releases/ReleaseNotesDash"
import ReleaseNote from "components/releases/ReleaseNote"
import ReleaseNotes from "components/releases/ReleaseNotes"
import CreatorsDash from "components/creators/CreatorsDash"
import Creator from "components/layout/Creator"



function RoutesView(props) {
    const rootStore = useStores()

    return (
        <Router>
            <Routes>
                {/* DEV */}
                {/* <Route path="/dev" component={Dev} exact /> */}
                {/*<Route path="/checkoutdev" element={<CheckoutDev />} exact />*/}

                <Route exact path='/affiliates' element={rootStore.AuthStore.user.hasRole('appDeveloper') ? <Layout><AffiliateDash /></Layout> : <Navigate to="/" />}/>

                {/* Query Builder */}
                <Route exact path='/chromaql' element={rootStore.AuthStore.user.hasRole('appDeveloper') ? <QueryBuilderView /> : <Navigate to="/login" />}/>
                
                {/* Login */}
                <Route path="/login" element={<Login />} exact />

                {/* Dashboard */}
                <Route exact path='/dashboard' element={rootStore.AuthStore.authenticated ? <Dashboard /> : <Navigate to="/login" />}/>
                
                {/* Creators Dashboard */}
                <Route exact path='/creator' element={rootStore.AuthStore.authenticated ? <Creator><CreatorsDash /></Creator> : <Navigate to="/login" />}/>

                {/* Settings */}
                <Route exact path='/settings' element={rootStore.AuthStore.authenticated ? <GeneralLayout><FormEditDashboard /></GeneralLayout> : <Navigate to="/login" />}/>

                {/* NFTs */}
                <Route exact path='/nfts' element={rootStore.AuthStore.authenticated ? <GeneralLayout><CryptoDash /></GeneralLayout> : <Navigate to="/login" />}/>

                {/* Admin */}
                <Route exact path='/admin' element={rootStore.AuthStore.user.hasRole('appDeveloper') ? <Layout><AdminDash /></Layout> : <Navigate to="/" />}/>
                <Route exact path='/admin/users' element={rootStore.AuthStore.user.hasRole('appDeveloper') ? <Layout><AdminUserDash /></Layout> : <Navigate to="/" />}/>
                <Route exact path='/admin/affiliates' element={rootStore.AuthStore.user.hasRole('appDeveloper') ? <Layout><AdminAffiliateDash /></Layout> : <Navigate to="/" />}/>
                <Route exact path='/admin/transactions' element={rootStore.AuthStore.user.hasRole('appDeveloper') ? <Layout><AdminTransactionDash /></Layout> : <Navigate to="/" />}/>

                {/* Worlds */}
                <Route path="/worlds" element={<Worlds />} exact />

                {/* Resources */}
                <Route path="/resources" element={<Resources />} exact />
                <Route exact path='/releases' element={rootStore.AuthStore.user.hasRole('appDeveloper') ? <Layout><ReleaseNotesDash /></Layout> : <Navigate to="/" />}/>
                <Route exact path='/releases/frontend' element={rootStore.AuthStore.user.hasRole('appDeveloper') ? <Layout><ReleaseNotes release="chroma-frontend" /></Layout> : <Navigate to="/" />}/>
                <Route exact path='/releases/desktop' element={rootStore.AuthStore.user.hasRole('appDeveloper') ? <Layout><ReleaseNotes release="desktop-hub" /></Layout> : <Navigate to="/" />}/>
                <Route exact path='/releases/api' element={rootStore.AuthStore.user.hasRole('appDeveloper') ? <Layout><ReleaseNotes release="api" /></Layout> : <Navigate to="/" />}/>
                <Route exact path='/releases/microdose' element={rootStore.AuthStore.user.hasRole('appDeveloper') ? <Layout><ReleaseNotes release="microdose" /></Layout> : <Navigate to="/" />}/>

                {/* Download */}
                <Route path="/download" element={<Download />} exact />

                {/* Products */}
                <Route path="/products" element={<Products />} exact />
                <Route exact path='/products/checkout' element={rootStore.AuthStore.authenticated ? <Purchase/> : <Navigate to="/login" />}/>
                {/*<PrivateRoute path="/products/checkout" element={<Purchase />} exact />*/}

                {/* Transactions */}
                <Route path="/tx/:transactionId" element={<Transaction />} exact />
                {/*<Route path="/transactions/:transactionId" element={<Transaction />} exact />*/}

                {/* Reload Utility */}
                <Route path="/reload" element={<Dashboard />} exact />

                {/* Legacy Link Redirects */}
                <Route path="/download-chroma" element={<Download />} exact />
                <Route path="/osc" element={<Resources />} exact />

                <Route path="/404" element={<Lost />} />

                {/* Profile */}
                <Route path="/:username" element={<Profile />} exact />

                {/* Single Views */}
                {/*<Route path="/:service/:id" element={<SingleView />} exact />*/}

                {/* Services View */}
                {/*<Route path="/assets" element={<Overview service="assets" header="🖼️ assets" />} exact />*/}

                {/* Root */}
                <Route path="/" element={<Home />} exact />

                {/* 404 */}
                <Route element={<Lost />} />

            </Routes>
        </Router>
    )
  }
  
  export default RoutesView